import React, { Component } from "react";
import { select, selectAll } from "d3-selection";
import Question from "./Charts/Question";
import "d3-transition";
import arrowSvg from "../static/arrow.svg";
import svg1 from "../static/emoji/1f393.svg"; // education
import svg2 from "../static/emoji/1f4aa.svg"; // ambition
import svg3 from "../static/emoji/1f939-1f3fd.svg"; // flexibility
import svg4 from "../static/emoji/26d1.svg"; // resilience
import svg5 from "../static/emoji/1f4bc.svg"; // job market
import svg6 from "../static/emoji/1f4bb.svg"; // tech skills
import svg7 from "../static/emoji/1f5e8.svg"; // social network
import svg8 from "../static/emoji/1f468-1f469-1f467.svg"; // family responsibilities
import svg9 from "../static/emoji/1f4b0.svg"; // Economic policies
import svg10 from "../static/emoji/1f30d.svg"; // global standing
import svg11 from "../static/emoji/1f6eb.svg"; // ability to work abroad
import svg12 from "../static/emoji/1f5e3.svg"; // foreign language skills
import svg13 from "../static/emoji/1f4e6.svg"; // trade relationships
import svg14 from "../static/emoji/1f3e6.svg"; // access to family capital
import svg15 from "../static/emoji/1f46b.svg"; // gender
import svg16 from "../static/emoji/1f6c2.svg"; // immigration

const svgHash = {
  "Level of education": svg1,
  Ambition: svg2,
  "Flexibility / Adaptability": svg3,
  Resilience: svg4,
  "Job market": svg5,
  "Tech skills": svg6,
  "Social network": svg7,
  "Family responsibilities": svg8,
  "Economic policy": svg9,
  "Global standing": svg10,
  "Ability to work abroad": svg11,
  "Foreign language skills": svg12,
  "Trade relationships": svg13,
  "Access to family capital": svg14,
  Gender: svg15,
  Immigration: svg16
};

const RankStyleAbilities = {
  fill: "#807266",
  stroke: "#807266",
  strokeWidth: "2px",
  strokeLinecap: "round"
};
const RankStyleFactors = {
  fill: "#D7C2AA",
  stroke: "#D7C2AA",
  strokeWidth: "2px",
  strokeLinecap: "round"
};

const rowSpace = 40;

class Controls extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    this.props.onChange(event.target.value);
  }

  render() {
    const isMobile = this.props.width > 768;
    const oCountry = isMobile ? this.props.otherCountry : null;
    //const width = isMobile ? "210px" : this.props.width+"px";

    return (
      <div
        className={
          this.props.side === "left"
            ? "controls-container controls-container-left"
            : "controls-container controls-container-right"
        }
      >
        <div>
          <form>
            <select value={this.props.country} onChange={this.handleChange}>
              <optgroup label="Markets: ">
                <option
                  disabled={oCountry === "Emerging markets"}
                  value="Emerging markets"
                >
                  Emerging markets
                </option>
                <option
                  disabled={oCountry === "Developed markets"}
                  value="Developed markets"
                >
                  Developed markets
                </option>
              </optgroup>
              <optgroup label="Countries: ">
                <option
                  disabled={oCountry === "United States"}
                  value="United States"
                >
                  United States
                </option>
                <option
                  disabled={oCountry === "United Kingdom"}
                  value="United Kingdom"
                >
                  United Kingdom
                </option>
                <option disabled={oCountry === "Germany"} value="Germany">
                  Germany
                </option>
                <option disabled={oCountry === "Singapore"} value="Singapore">
                  Singapore
                </option>
                <option disabled={oCountry === "Russia"} value="Russia">
                  Russia
                </option>
                <option disabled={oCountry === "China"} value="China">
                  China
                </option>
                <option disabled={oCountry === "India"} value="India">
                  India
                </option>
                <option
                  disabled={oCountry === "United Arab Emirates"}
                  value="United Arab Emirates"
                >
                  United Arab Emirates
                </option>
                <option disabled={oCountry === "Mexico"} value="Mexico">
                  Mexico
                </option>
                <option
                  disabled={oCountry === "South Africa"}
                  value="South Africa"
                >
                  South Africa
                </option>
              </optgroup>
            </select>
          </form>
          <RankList
            list={this.props.answers}
            country={this.props.country}
            personalAbilities={this.props.personalAbilities}
            side={this.props.side}
          />

        </div>
        <style jsx>{`
          .controls-container {
            flex: 1 1 0%;
          }
          .controls {
            width: 100%;
          }
          select {
            width: 100%;
            margin: 20px 0 10px 0;
            padding: 10px;
            border: 1px solid #646464;
            border-radius: 0;
            font-family: FrutigerLTCom;
            font-size: 14px;
            appearance: none;
            -webkit-appearance: none;
            background: url('${arrowSvg}') no-repeat right;
            background-position-x: 95%;
          }
          select:focus {
            outline: none;
          }
          select::-ms-expand {
            display: none;
          }
          @media screen and (max-width : 768px) {
              .controls-container-left {
                   display: none;
              }
          }
        `}</style>
      </div>
    );
  }
}

class RankList extends Component {
  componentDidMount() {
    const thisNode = select(this.node);
    const listItems = thisNode.selectAll("div.rank-list-item");
    listItems.transition().duration(0).style("transform", function(d, i) {
      return "translate(0px, " + i * rowSpace + "px)";
    });

    listItems.on("mouseover", (d, i) => {
      selectAll("div.rank-list-item").style("opacity", ".3");
      selectAll("line").style("stroke-opacity", ".3");
      const val = thisNode
        .select("div.rank-list-item#id" + i + "")
        .attr("value");
      selectAll('div.rank-list-item[value = "' + val + '"]').style(
        "opacity",
        "1"
      );
      select('line[value = "' + val + '"]')
        .style("stroke-opacity", "1")
        .raise();
    });

    selectAll(".controls-container").on("mouseleave", (d, i) => {
      selectAll("div.rank-list-item").style("opacity", "1");
      selectAll("line").style("stroke-opacity", "1");
    });
  }

  componentDidUpdate() {
    const thisNode = select(this.node);
    const listItems = select(this.node).selectAll("div.rank-list-item");
    listItems.transition().duration(1000).style("transform", function(d, i) {
      return "translate(0px, " + i * rowSpace + "px)";
    });

    listItems.on("mouseover", (d, i) => {
      selectAll("div.rank-list-item").style("opacity", ".3");
      selectAll("line").style("stroke-opacity", ".3");
      const val = thisNode
        .select("div.rank-list-item#id" + i + "")
        .attr("value");
      selectAll('div.rank-list-item[value = "' + val + '"]').style(
        "opacity",
        "1"
      );
      select('line[value = "' + val + '"]')
        .style("stroke-opacity", "1")
        .raise();
    });
  }

  render() {
    const TheseAnswers = this.props.list
      .find(d => d.country === this.props.country)
      .answers.sort((a, b) => {
        return b.value - a.value;
      });
    return (
      <div
        className="rank-list"
        ref={rankListDiv => {
          this.node = rankListDiv;
        }}
      >
        {TheseAnswers.map((d, i) => {
          return (
            <div
              className={
                this.props.side === "left"
                  ? "rank-list-item rank-list-item-left"
                  : "rank-list-item rank-list-item-right"
              }
              key={d.key}
              id={"id" + i}
              value={d.key}
            >
              <img
                src={svgHash[d.key]}
                alt={"emoji " + d.key}
                width="24px"
                height="24px"
              />
              <div
                className={
                  this.props.side === "left"
                    ? "rank-label rank-label-left"
                    : "rank-label rank-label-right"
                }
              >
                {d.key}
              </div>
              <div
                className="rank-number"
                style={{
                  color: this.props.personalAbilities.includes(d.key)
                    ? RankStyleAbilities.fill
                    : "#B89D83",
                  textAlign: this.props.side === "left" ? "right" : "left"
                }}
              >
                {i + 1}
              </div>
            </div>
          );
        })}
        <style jsx>{`
          .rank-list {
            position: relative;
            padding-top: 12px;
          }
          .rank-list-item {
            position: absolute;
            width: 100%;
            height: 30px;
            display: flex;
            align-items: center;
            justify-content: space-between;
          }
         .rank-list-item-left {
            flex-direction: row;
          }
          .rank-list-item-right {
            flex-direction: row-reverse;
          }
          .rank-label {
            color: #333;
            font-family: FrutigerLTCom;
            font-size: 16px;
            font-weight: 300;
            padding: 0 10px 0 10px;
            cursor: default;
          }
          .rank-label-left {
            margin-left: auto;
          }
          .rank-label-right {
            margin-right: auto;
          }
          .rank-number {
            font-family: FrutigerLTCom;
            font-size: 16px;
            font-weight: 700;
            width: 16px;
          }
          @media screen and (max-width : 768px) {
              .rank-list {
                   pointer-events: none;
              }
          }
        `}</style>
      </div>
    );
  }
}

class Slope extends Component {
  componentDidMount() {
    const LeftAnswers = this.props.answers
      .find(d => d.country === this.props.LeftCountry)
      .answers.sort((a, b) => {
        return b.value - a.value;
      });
    const RightAnswers = this.props.answers
      .find(d => d.country === this.props.RightCountry)
      .answers.sort((a, b) => {
        return b.value - a.value;
      });

    RightAnswers.forEach((d, i) => {
      d.rank = i;
    });

    const lines = select(this.node).selectAll("line");

    lines
      .transition()
      .duration(0)
      .attr("y1", function(d, i) {
        let id = select(this).attr("id");
        return id * rowSpace;
      })
      .attr("y2", function(d, i) {
        let id = select(this).attr("id");
        let rightRank = RightAnswers.find(r => r.key === LeftAnswers[id].key);
        return rightRank.rank * rowSpace;
      });
  }

  componentDidUpdate() {
    const LeftAnswers = this.props.answers
      .find(d => d.country === this.props.LeftCountry)
      .answers.sort((a, b) => {
        return b.value - a.value;
      });
    const RightAnswers = this.props.answers
      .find(d => d.country === this.props.RightCountry)
      .answers.sort((a, b) => {
        return b.value - a.value;
      });

    RightAnswers.forEach((d, i) => {
      d.rank = i;
    });

    const lines = select(this.node).selectAll("line");

    lines
      .transition()
      .duration(1000)
      .attr("y1", function(d, i) {
        let id = select(this).attr("id");
        return id * rowSpace;
      })
      .attr("y2", function(d, i) {
        let id = select(this).attr("id");
        let rightRank = RightAnswers.find(r => r.key === LeftAnswers[id].key);
        return rightRank.rank * rowSpace;
      });
  }

  render() {
    const LeftAnswers = this.props.answers
      .find(d => d.country === this.props.LeftCountry)
      .answers.sort((a, b) => {
        return b.value - a.value;
      });

    return (
      <div>
        <svg className="svg-slope" width="300px" height="640px">
          <g
            className="slopes-group"
            ref={node => {
              this.node = node;
            }}
          >
            {LeftAnswers.map((d, i) => {
              return (
                <line
                  key={d.key}
                  id={i}
                  value={d.key}
                  x1={20}
                  y1={0}
                  x2={280}
                  y2={0}
                  style={
                    this.props.personalAbilities.includes(d.key)
                      ? RankStyleAbilities
                      : RankStyleFactors
                  }
                />
              );
            })}
          </g>
        </svg>
        <style jsx>{`
          svg {
            display: block;
          }
          .svg-slope {
            padding-top: 98px;
          }
          @media screen and (max-width : 768px) {
              .svg-slope {
                   display: none;
              }
          }
        `}</style>
      </div>
    );
  }
}

class ColorLegend extends Component {
  render() {
    return (
      <div className="legend-container">
        <div className="color-legend">
          <div className="color-legend-title">Areas of influence</div>
          <div className="color-legend-items">
            <div>
              <svg className="left-legend-item" width="10px" height="10px">
                <circle cx="5" cy="5" r="5" stroke="none" fill="#807266" />
              </svg>
              Personal abilities
            </div>
            <div>
              <svg width="10px" height="10px">
                <circle cx="5" cy="5" r="5" stroke="none" fill="#D7C2AA" />
              </svg>
              Societal factors
            </div>
          </div>
          <div className="source">
            Source: unlimited.world survey of affluent millennials, UBS. Data as of October 2016. N = 2,130.
          </div>
        </div>
        <style jsx>{`
          .legend-container {
            font-family: FrutigerLTCom;
            width: 100%;
            padding-top: 8px;
          }
          .color-legend {
            display: flex;
            height: 78px;
            flex-direction: column;
            align-items: center; 
            justify-content: center;
            font-size: 14px;
          }
          .color-legend-title {
            display: flex;
            justify-content: center;
            width: 100%;
            height: 26px;
            font-weight: 700;
          }
          .color-legend-items {
            display: flex;
            justify-content: center;
            width: 100%;
            font-weight: 300;
            height: 26px;
          }
          svg {
            padding-left: 15px;
            padding-right: 8px;
          }
          .source {
            font-size: 11px;
            font-weight: 300;
            display: flex;
            justify-content: center;
            width: 100%;
            color: #888;
            height: 26px;
          }
          @media screen and (max-width : 768px) {
              .color-legend-title, .color-legend-items, .source {
                align-items: flex-start; 
                justify-content: flex-start;
              }
              .left-legend-item {
                padding-left: 0;
              }
              
              .legend-container {
                align-self: flex-start;
              }
          }
          `}</style>
      </div>
    );
  }
}

export default class SlopeChartFactors extends Component {
  constructor(props) {
    super(props);
    this.state = {
      LeftCountry: "Developed markets",
      RightCountry: "Emerging markets"
    };

    this.handleLeftChange = this.handleLeftChange.bind(this);
    this.handleRightChange = this.handleRightChange.bind(this);
  }

  handleLeftChange(country) {
    this.setState({
      LeftCountry: country,
      otherCountry: this.state.RightCountry
    });
  }

  handleRightChange(country) {
    this.setState({
      RightCountry: country
    });
  }

  render() {
    const personalAbilities = [
      "Level of education",
      "Ambition",
      "Flexibility / Adaptability",
      "Resilience",
      "Tech skills",
      "Social network",
      "Foreign language skills"
    ];
    return (
      <div className="whole-chart">
        <Question />
        <div className="viz">
          <Controls
            answers={this.props.data}
            country={this.state.LeftCountry}
            otherCountry={this.state.RightCountry}
            onChange={this.handleLeftChange}
            personalAbilities={personalAbilities}
            side="left"
            width={this.props.width}
          />
          <Slope
            className="slope"
            answers={this.props.data}
            LeftCountry={this.state.LeftCountry}
            RightCountry={this.state.RightCountry}
            personalAbilities={personalAbilities}
          />
          <Controls
            answers={this.props.data}
            country={this.state.RightCountry}
            otherCountry={this.state.LeftCountry}
            onChange={this.handleRightChange}
            personalAbilities={personalAbilities}
            side="right"
            width={this.props.width}
          />
        </div>
        <ColorLegend />
        <style jsx>{`
          .whole-chart {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 100%;
          }
					.viz {
            display: flex;
            width: 100%;
            height: 730px;
          }
		        `}</style>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/SlopeChartFactors.js